import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Drawer,
  FormControl,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { CancelOutlined, MoreHoriz } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../Redux/Store";
import { clearShowMenu } from "../../../../Redux/Reducers/GlobalVar";
import CommonStatus from "../../../Common/CommonStatus/CommonStatus";
import DeletePopup from "../../../Common/DeletePopup/DeletePopup";
import { toast } from "react-toastify";
import CommonMenu from "../../../Common/CommonMenu/CommonMenu";
import CommonShimmer from "../../../Common/CommonShimmer/CommonShimmer";
import {
  DragDropContext,
  Droppable,
  Draggable,
  DropResult,
} from "@hello-pangea/dnd";
import { DragIndicator } from "@mui/icons-material";
import {
  apiCallEQualityAdd,
  apiCallEqualityList,
  apiCallEqualityUpdate,
  apiCallStatusUpdate,
} from "../../../../Core/Apicall";

interface Type {
  _id?: string;
  quality: string;
  isActive: boolean;
  isDelete: boolean;
  displayOrder: string;
}

function Qualities() {
  const [data, setData] = useState<Type[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [statusDialogOpen, setStatusDialogOpen] = useState<any>(false);
  const showMenu: any = useSelector(
    (state: RootState) => state.global.showMenu,
  );
  const [isCreateNew, setIsCreateNew] = useState<boolean>(!!showMenu);
  useEffect(() => {
    setIsCreateNew(!!showMenu);
  }, [showMenu]);
  const [formData, setFormData] = useState<any>({
    Id: "",
    Name: "",
    isActive: true,
    isDelete: false,
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuVibe, setMenuVibe] = useState<Type | null>(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await apiCallEqualityList("");
      setData(res?.data);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      if (formData.Id) {
        const payload = {
          qualityId: formData.Id,
          quality: formData.Name,
          displayOrder: formData.displayOrder,
        };
        const res = await apiCallEqualityUpdate(payload);
        toast.success(res.message || "Updated successfully!");
      } else {
        const data = {
          quality: formData.Name,
        };
        const res = await apiCallEQualityAdd(data);
        toast.success(res.message || "Added successfully!");
      }
      setIsCreateNew(false);
      fetchData();
      setFormData({
        Name: "",
        displayOrder: "",
        isActive: true,
        isDelete: false,
      });
    } catch (err) {
      toast.error("Failed to save ");
    }
  };

  const handleStatusUpdate = async (type: any) => {
    try {
      const payload = {
        type: "quality",
        typeId: type._id,
        isActive: !type.isActive,
      };

      await apiCallStatusUpdate(payload);
      setData((prev) =>
        prev.map((d) =>
          d._id === type._id ? { ...d, isActive: !type.isActive } : d,
        ),
      );
      setStatusDialogOpen(false);
    } catch (err) {}
  };
  const handleDelete = async () => {
    if (!menuVibe) return;
    try {
      const payload = {
        type: "quality",
        typeId: menuVibe._id,
        isDelete: !menuVibe.isDelete,
      };

      await apiCallStatusUpdate(payload);
      setData((prev) => prev.filter((item) => item._id !== menuVibe._id));
    } catch (err) {
    } finally {
      setDeleteDialogOpen(false);
      setMenuVibe(null);
    }
  };

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>, type: any) => {
    setAnchorEl(event.currentTarget);
    setMenuVibe(type);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    {
      label: "Edit",
      onClick: () => {
        if (menuVibe) {
          setFormData({
            ...menuVibe,
            Id: menuVibe._id,
            Name: menuVibe.quality,
          });
          setIsCreateNew(true);
        }
        handleMenuClose();
      },
    },
    {
      label: "Delete",
      onClick: () => setDeleteDialogOpen(true),
    },
  ];
  const handleDragEnd = async (result: DropResult) => {
    if (!result.destination) return;
    const newData = Array.from(data);
    const [movedItem] = newData.splice(result.source.index, 1);
    newData.splice(result.destination.index, 0, movedItem);
    setData(newData);
    try {
      for (let i = 0; i < newData.length; i++) {
        const item = newData[i];

        const payload = {
          qualityId: item._id,
          displayOrder: i + 1,
        };
        await apiCallEqualityUpdate(payload);
        fetchData();
      }
    } catch (error) {}
  };

  return (
    <Box style={{ paddingBottom: "20px" }}>
      <Box className="d-flex input align-items-center justify-content-between">
        <TextField
          className="border-10"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ backgroundColor: "white" }}
          placeholder="Search.."
        />
        <Button
          className="btn-black p-2 px-3"
          onClick={() => {
            setFormData({
              Id: "",
              Name: "",
              displayOrder: "",
              iconPath: "",
              isActive: true,
              isDelete: false,
            });
            setIsCreateNew(true);
          }}
        >
          + Create New
        </Button>
      </Box>

      <Paper
        className="bg-white mt-3 border-20 scroll-bar"
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          position: "relative",
        }}
      >
        <TableContainer className="scroll-bar">
          <DragDropContext onDragEnd={handleDragEnd}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>Display Order</TableCell>
                  <TableCell>Name</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Action</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <Droppable droppableId="kids-table">
                {(provided) => (
                  <TableBody
                    ref={provided.innerRef}
                    {...provided.droppableProps}
                  >
                    {data
                      .filter(
                        (item) =>
                          search === "" ||
                          item.quality
                            .toLowerCase()
                            .includes(search.toLowerCase()),
                      )
                      .map((item, index) => (
                        <Draggable
                          key={item._id}
                          draggableId={item._id!}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <TableRow
                              hover
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              sx={{
                                backgroundColor: snapshot.isDragging
                                  ? "#f9f9f9"
                                  : "white",
                                ...(snapshot.isDragging && {
                                  display: "table",
                                  boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
                                  borderRadius: "8px",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  width: "100%",
                                }),
                              }}
                              style={provided.draggableProps.style}
                            >
                              <TableCell>{item.displayOrder}</TableCell>
                              <TableCell>{item.quality}</TableCell>
                              <TableCell>
                                <Button
                                  className={
                                    item?.isActive
                                      ? "btn-success"
                                      : "btn-danger"
                                  }
                                  onClick={() => setStatusDialogOpen(index)}
                                >
                                  {item?.isActive ? "Active" : "Inactive"}
                                </Button>
                                <CommonStatus
                                  open={statusDialogOpen === index}
                                  title={item?.quality}
                                  message={`Are you sure you want to ${
                                    item?.isActive ? "deactivate" : "activate"
                                  } this venue?`}
                                  confirmText={
                                    item?.isActive ? "Deactivate" : "Activate"
                                  }
                                  confirmColor={
                                    item?.isActive ? "warning" : "success"
                                  }
                                  onConfirm={() => handleStatusUpdate(item)}
                                  onClose={() => setStatusDialogOpen(false)}
                                />
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  onClick={(e) => handleMenuOpen(e, item)}
                                >
                                  <MoreHoriz />
                                </IconButton>
                              </TableCell>
                              <TableCell
                                {...provided.dragHandleProps} // 👈 only handle drag here
                                align="center"
                              >
                                <DragIndicator
                                  sx={{ cursor: "grab", color: "#888" }}
                                />
                              </TableCell>
                            </TableRow>
                          )}
                        </Draggable>
                      ))}

                    {provided.placeholder}
                  </TableBody>
                )}
              </Droppable>
            </Table>
          </DragDropContext>

          {loading && (
            <div style={{ padding: "10px 10px" }}>
              <CommonShimmer />
            </div>
          )}
          {data.length === 0 && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Data not found
            </div>
          )}
        </TableContainer>
      </Paper>

      <CommonMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        items={menuItems}
      />

      <DeletePopup
        open={deleteDialogOpen}
        title="Confirm Delete"
        message="Are you sure you want to delete this venue?"
        confirmText="Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onClose={() => setDeleteDialogOpen(false)}
      />

      <Drawer
        anchor="right"
        open={isCreateNew}
        onClose={() => {
          setIsCreateNew(false);
          dispatch(clearShowMenu());
        }}
        PaperProps={{
          sx: {
            width: "35%",
            borderRadius: "16px 0 0 16px",
            overflow: "hidden",
          },
        }}
      >
        <Box
          className="drink-form"
          height="100%"
          display="flex"
          flexDirection="column"
        >
          {/* ---------- Header ---------- */}
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            px={3}
            py={2}
            borderBottom="1px solid #eee"
            bgcolor="#fafafa"
          >
            <Typography variant="h6" fontWeight={600}>
              {formData.Id ? "Edit Qualities" : "Create Qualities"}
            </Typography>
            <IconButton
              onClick={() => {
                setIsCreateNew(false);
                dispatch(clearShowMenu());
              }}
            >
              <CancelOutlined />
            </IconButton>
          </Box>

          {/* ---------- Form ---------- */}
          <Box flex={1} px={3} py={2} overflow="auto">
            <form onSubmit={handleSubmit}>
              {/* Drink Name */}
              <FormControl fullWidth sx={{ mb: 3 }}>
                <Typography variant="body2" fontWeight={500} mb={1}>
                  Name
                </Typography>
                <TextField
                  name="Name"
                  value={formData.Name}
                  onChange={handleChange}
                  placeholder="Enter Name"
                  fullWidth
                />
              </FormControl>

              <Button
                type="submit"
                variant="contained"
                fullWidth
                sx={{
                  borderRadius: "10px",
                  py: 1.2,
                  fontWeight: 600,
                  textTransform: "none",
                  backgroundColor: "#000",
                  "&:hover": { backgroundColor: "#222" },
                }}
              >
                Save
              </Button>
            </form>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
}

export default Qualities;
